import { useState, useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import type { ProductReviewRating } from 'hpdp/services/reviews'
import { getProductsReviewsRating } from 'hpdp/services/reviews'

interface UseRatingProps {
  ids: number[]
}

export function useRating(props: UseRatingProps) {
  const { ids } = props

  const [data, setData] = useState<ProductReviewRating[]>([])
  const [isLoading, setisLoading] = useState(false)

  const serializedIds = JSON.stringify(ids)

  useEffect(() => {
    const ids = JSON.parse(serializedIds) as number[]

    const getReviews = async () => {
      try {
        setisLoading(true)

        const response = await getProductsReviewsRating(ids)

        setData(response)
      } catch (e) {
        datadogRum.addError(e)
      } finally {
        setisLoading(false)
      }
    }

    if (ids.length >= 1) {
      getReviews()
    }
  }, [serializedIds])

  return {
    data,
    isLoading
  }
}
